module.exports = __webpack_public_path__ + "static/img/backtotop_btn.a97621b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/backtotop_btn.png
// module id = umam
// module chunks = 0